import { getBundleDefinition } from "@/features/payment/paymentDefinitions";
import type { BundleEntitlementKey } from "@/features/payment/types";
import { HoverIdleModel } from "@/features/hoverIdle/core/hoverIdleModel";

export interface EntitlementSyncResult {
  readonly didChange: boolean;
  readonly didApplyRewards: boolean;
}

export function syncEntitlementsAndApplyEffects(
  model: HoverIdleModel,
  entitlements: readonly BundleEntitlementKey[],
): EntitlementSyncResult {
  let didChange = false;
  let didApplyRewards = false;

  for (const entitlement of entitlements) {
    if (!model.hasEntitlement(entitlement)) {
      const grant = model.grantEntitlement(entitlement);
      if (grant.ok) {
        didChange = true;
      }
    }
    if (model.isEntitlementClaimed(entitlement)) {
      continue;
    }

    const definition = getBundleDefinition(entitlement);
    if (definition.tokenGrant > 0) {
      model.grantToken(definition.tokenGrant);
    }
    if (definition.hovGrant > 0) {
      model.grantHov(definition.hovGrant);
    }
    if (definition.timGrant > 0) {
      model.grantTim(definition.timGrant);
    }
    for (const permanentId of definition.permanentEffectGrants) {
      model.grantPermanentEffectFromBundle(permanentId);
    }
    if (model.markEntitlementClaimed(entitlement)) {
      didChange = true;
      didApplyRewards = true;
    }
  }

  return {
    didChange,
    didApplyRewards,
  };
}
